// Bundle "Add to Cart" — posts to admin-ajax.php?action=haegoziya_add_bundle
// which inserts every bundle product into the cart and applies a discount fee.
// On success: refresh the cart fragments (mini-cart count) and show a toast.

import { getAjaxUrl } from './_ajax.js';

// Button micro-copy — translated server-side and passed through the
// HAEGOZIYA.i18n localize bag, with English fallbacks for safety.
function t(key, fallback) {
    return (window.HAEGOZIYA && window.HAEGOZIYA.i18n && window.HAEGOZIYA.i18n[key]) || fallback;
}

async function addBundle(btn) {
    const id = btn.getAttribute('data-bundle-id');
    if (!id) return;

    btn.disabled = true;
    const orig = btn.textContent;
    btn.textContent = t('adding', 'Adding…');

    try {
        const fd = new FormData();
        fd.append('action', 'haegoziya_add_bundle');
        fd.append('bundle_id', id);
        const res = await fetch(getAjaxUrl(), { method: 'POST', body: fd, credentials: 'same-origin' });
        const json = await res.json();
        if (json && json.success) {
            btn.textContent = t('added', 'Added');
            // Notify the centralized cart-count keeper (cart-count.js) so the
            // header badge bumps immediately — json.data.cart_count is the
            // fresh whole-cart total from the server.
            document.dispatchEvent(new CustomEvent('haegoziya:cart-updated', { detail: json.data }));
            if (window.jQuery) window.jQuery(document.body).trigger('added_to_cart');
            setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 1500);
        } else {
            btn.textContent = t('try_again', 'Try again');
            setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 1500);
        }
    } catch (e) {
        btn.textContent = t('try_again', 'Try again');
        btn.disabled = false;
    }
}

document.addEventListener('click', e => {
    const btn = e.target.closest('[data-bundle-add]');
    if (!btn) return;
    e.preventDefault();
    addBundle(btn);
});
